<script>
  import { onMount, createEventDispatcher } from "svelte";
  
  const dispatch = createEventDispatcher();
  const PAGE_SIZE = 20;
  const defaultFeed = { name: "", uri: "", format: "", xpath: ""
    //freshness_minutes
  }
  export let page = 1;
  export let url = '/my/feeds/feeds.json';
  export let active_feed_id = null;
  
  let offset = 0;
  let feeds = [];
  
  onMount(getFeeds);
  
  function filterFeed(feed_id) {
    active_feed_id = feed_id;
    dispatch("filterFeed", feed_id);
  }
  
  function changePage(p) {
    if (p <= 0)
      p = 1;
    page = p;
    getAll();
  }
  
  function getFeeds() {
    fetch(url + `?page=${page}`)
      .then(function(r) {
        if (r.ok) return r;
        throw Error(r.statusText);
        console.log(data)
      })
      .then(r => r.json())
      .then(data => {
        if (!data.data)
          return;
        if (!(data.data instanceof Array) && data.length)
          feeds = [Object.assign({}, defaultFeed, data.data)];
        else {
          feeds = [];
          for(var i in data.data)
            feeds.push(Object.assign({}, defaultFeed, data.data[i]));
        }
        // offset = PAGE_SIZE * (data.page - 1);
        window.scrollTo(0, 0);
      })
      .catch(function(error) {
        console.log(error);
      });
  }
</script>
<div class='d-block'>
{#if feeds}
<ol class='list-group list-group-flush'>
{#each feeds as feed, i}
<li class:active='{active_feed_id == feed.id}' class='list-group-item list-group-item-action d-flex justify-content-start'>
<a class='stretched-link elipsis' href='{feed.uri}' on:click|preventDefault='{() => filterFeed(feed.id)}' title='Zobrazit'>
<div class='pr-1 d-inline-block'>
<i class:fa-rss='{feed.format=='rss'}' class:fa-video='{feed.format=='youtube'}' class='fa fa-external-link-alt'></i>
</div>
{feed.name}
</a>
</li>
{/each}
</ol>
{#if feeds.length > 10}
<div class='x_content'>
<nav class='nav col-10 offset-2'>
{#if page != 1 }
<a class='nav-link' href='?page={page-1}' on:click|preventDefault='{() => changePage(page-1)}'>
Předchozí
</a>
{/if}
{#if feeds.length }
<a class='nav-link' href='?page={page+1}' on:click|preventDefault='{() => changePage(page+1)}'>
Další
</a>
{/if}
</nav>
</div>
{/if}
{/if}
</div>

